import { faWarning } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Typography, Link } from '@mui/material'
import { Stack } from '@mui/system'
import { Trans } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useTenant } from 'src/app/hooks/context/context.hook'

export default function PrivacyNotConfiguredWarning({ messageKey }: { messageKey: string }) {
  const { privacySettings } = useTenant()
  const navigate = useNavigate()
  return (
    <>
      {!privacySettings && (
        <Stack direction={'row'} justifyContent="flex-start" alignItems="center" spacing={1} sx={{ backgroundColor: 'rgba(253, 185, 39, 0.2)', borderRadius: '3px' }} paddingX={0.7} paddingY={0.5}>
          <FontAwesomeIcon icon={faWarning} color="var(--Crayola)" />
          <Typography variant="body">
            <Trans i18nKey={messageKey as any} components={[<Link href="#" color="inherit" style={{ marginLeft: 0 }} onClick={() => navigate('/settings/privacy')} />]} />
          </Typography>
        </Stack>
      )}
    </>
  )
}
